import { Injectable } from '@angular/core';
import { Observable, shareReplay, switchMap } from 'rxjs';
import { Contact } from '@models';
import { FirestoreService } from './firestore.service';
import { TenantContextService } from './tenant-context.service';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  public all$: Observable<Contact[]>;

  constructor(
    private readonly firestore: FirestoreService,
    private readonly tenantContext: TenantContextService,
  ) {
    this.all$ = this.tenantContext.tenantId$.pipe(
      switchMap(() =>
        this.firestore.listDocuments<Contact>(
          this.tenantContext.collections.CONTACTS,
        ),
      ),
      shareReplay(1),
    );
  }

  async create(
    data: Omit<Contact, 'id' | 'createdAt' | 'updatedAt'>,
  ): Promise<string> {
    return this.firestore.create<Contact>(
      this.tenantContext.collections.CONTACTS,
      data,
    );
  }

  async update(data: Partial<Contact> & { id: string }): Promise<void> {
    return this.firestore.update<Contact>(
      this.tenantContext.collections.CONTACTS,
      data,
    );
  }

  async delete(id: string): Promise<void> {
    return this.firestore.delete(this.tenantContext.collections.CONTACTS, id);
  }
}
